<div id="pac-container" class="form-group">
	<ng-container *ngIf="showLabel">
		<label>{{ 'SearchLocation' | translate }}</label>
	</ng-container>
	<input #pacInput id="pac-input" class="form-control" type="text" placeholder="{{ 'EnterLocation' | translate }}" />
</div>